
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons' // PRO solid

import { computed, ref } from '@nuxtjs/composition-api';
import usePlaymix from '@/composable/usePlaymix';
import usePlayInfoModal from '@/composable/usePlayInfoModal';

export default {
  components: { FontAwesomeIcon },
  props: {
    identifier: {
      type: String,
      default: ''
    },
    invertedVersion: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { selected, data, selection } = usePlaymix(props.identifier);
    const { showModal, openModal: openModalBase, closeModal } = usePlayInfoModal();

    const hoverIndex = ref(null);
    const currentView = ref('play-mix-services-info');

    const openModal = (view) => {
      currentView.value = view;
      openModalBase();
    };

    const onChange = (e) => {
      if (selection.value.includes(e)) {
        const arr = [...selection.value];
        arr[selection.value.indexOf(e)] = null;
        selection.value = arr;
        return;
      }
      let isSet = false;
      selection.value.forEach((item, i) => {
        if (item === null && !isSet) {
          const arr = [...selection.value];
          arr[i] = e;
          selection.value = arr;
          isSet = true;
        }
      });
    };

    const handleClick = (toggle, index) => {
      if (props.disabled) {
        return;
      }
      toggle();
      onChange(index);
    };

    return {
      playProductOfferings: computed(() =>
        data.value.productOfferingDTOWithContent.sort(
          (a, b) => a.productOfferingDTO.priority - b.productOfferingDTO.priority
        )
      ),
      openModal,
      closeModal,
      showModal,
      selection,
      selected,
      data,
      hoverIndex,
      onChange,
      handleClick,
      currentView,
      faCheck,
      faXmark
    };
  }
};
